@let emptyDescription = description();
<div class="rbi-empty-state" [class.rbi-empty-state--overlay]="appearance() === 'overlay'">
    <i [class]="iconClass()" aria-hidden="true"></i>
    <p class="rbi-empty-state__title">{{ title() }}</p>
    @if (emptyDescription) {
        <p class="rbi-empty-state__description">{{ emptyDescription }}</p>
    }
    <div class="rbi-empty-state__action"><ng-content></ng-content></div>
</div>
